export default __webpack_public_path__ + "static/media/Jason-Orien.7bb88573.png";